<div>
    <mat-table #table style="width: 100%;" multiTemplateDataRows [dataSource]="angularMatData" class="mat-elevation-z0">
        <ng-container matColumnDef="contactKey">
            <mat-header-cell *matHeaderCellDef style="flex: .4; padding-left: 10px"></mat-header-cell>
            <mat-cell *matCellDef="let contact" style="flex: .4; padding-left: 10px"
                (click)="!contact.IsHeader ? '' : $event.stopPropagation()">
            </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef style="flex: 4;">
                <span style="padding-left: 20px;" translate>Name</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let contact" style="flex: 4;"
                (click)="!contact.IsHeader ? '' : $event.stopPropagation()">
                <span style="padding-left: 20px;" *ngIf="!contact.IsHeader"
                    [ngClass]="{'restricted-contact' : (contact.IsRestricted || (!contact.IsEnableLeaveWithHousehold && contact.ParentType != 'Emergency'))}">{{contact.Contact_Name}}</span>
                <span *ngIf="contact.IsHeader">
                    <b>{{contact.Contact_Name}}</b>
                </span>
            </mat-cell>
        </ng-container>

        <!-- Relationship Column -->
        <ng-container matColumnDef="relationship">
            <mat-header-cell *matHeaderCellDef style="flex: 4">
                <span translate>Relationship</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let contact" style="flex: 4"
                (click)="!contact.IsHeader ? '' : $event.stopPropagation()"
                [ngClass]="{'restricted-contact' : (contact.IsRestricted || (!contact.IsEnableLeaveWithHousehold && contact.ParentType != 'Emergency'))}">
                {{contact.Relationship}}</mat-cell>
        </ng-container>

        <!--  Home Column -->
        <ng-container matColumnDef="home">
            <mat-header-cell *matHeaderCellDef style="flex: 4">
                <span translate>Home</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let contact" style="flex: 4"
                (click)="!contact.IsHeader ? '' : $event.stopPropagation()"
                [ngClass]="{'restricted-contact' : (contact.IsRestricted || (!contact.IsEnableLeaveWithHousehold && contact.ParentType != 'Emergency'))}">
                <span *ngIf="contact.HomeNumber != ''">{{contact.HomeNumber | phoneNumber}}</span>
                <span *ngIf="contact.HomeNumber == ''"></span>
            </mat-cell>
        </ng-container>

        <!--  Cell Column -->
        <ng-container matColumnDef="cell">
            <mat-header-cell *matHeaderCellDef style="flex: 4">
                <span translate>Cell</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let contact" style="flex: 4"
                (click)="!contact.IsHeader ? '' : $event.stopPropagation()"
                [ngClass]="{'restricted-contact' : (contact.IsRestricted || (!contact.IsEnableLeaveWithHousehold && contact.ParentType != 'Emergency'))}">
                <span *ngIf="contact.CellNumber != ''">{{contact.CellNumber | phoneNumber}}</span>
                <span *ngIf="contact.CellNumber == ''">{{contact.CellNumber | phoneNumber}}</span>
            </mat-cell>
        </ng-container>

        <!-- More Column -->
        <ng-container matColumnDef="more">
            <mat-header-cell *matHeaderCellDef style="min-width:68px;max-width:68px;text-align:center;"
                class="print-ignore"></mat-header-cell>
            <mat-cell *matCellDef="let AH" style="min-width:68px;max-width:68px;justify-content: center;"
                class="print-ignore" (click)="!AH.IsHeader ? '' : $event.stopPropagation()">
                <span aria-label="Expand row for more details" *ngIf="!AH.IsHeader">
                    <i [ngClass]="checkExpanded(AH) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'"
                        aria-hidden="true"></i>
                </span>
            </mat-cell>
        </ng-container>

        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
            <!-- Detail row can have standard html or another Angular Material table -->
            <mat-cell *matCellDef="let contactDetails" [attr.colspan]="displayedColumns.length"
                style="width:100%;margin-left: 45px;">
                <!-- WHEN PARENT TYPE IS HOUSE HOLD -->
                <div *ngIf="!contactDetails.IsHeader && contactDetails.ParentType != 'Emergency'"
                    style="flex: 1; display: flex; flex-direction: column">
                    <div style="display: flex; flex: 1; white-space: nowrap;margin-bottom: 10px;">
                        <span *ngIf="contactDetails.IsEnableLeaveWithHousehold">
                            Student may leave with this person
                        </span>
                        <span *ngIf="!contactDetails.IsEnableLeaveWithHousehold" style="color: red;font-weight: bold;">
                            Student may NOT leave with this person
                        </span>
                    </div>
                    <div style="display: flex; flex: 1">
                        <div style="display: flex; flex: 1; flex-direction: column;max-width: 60%;">
                            <div class="row-details">
                                <div class="row-Label-width">Email Address</div>
                                <div class="row-Value-width" style="text-align: left;"><span class="link"
                                        style="color:#3f51b5"
                                        (click)="sendEmail(contactDetails.Name, contactDetails.Email)">{{contactDetails.Email}}</span>
                                </div>
                            </div>

                            <div class="row-details" *ngIf="contactDetails.ParentType != 'Emergency'">
                                <div class="row-Label-width">Employer</div>
                                <div class="row-Value-width" style="text-align: left;">{{contactDetails.Employer}}</div>
                            </div>

                            <div class="row-details">
                                <div class="row-Label-width">Work Phone</div>
                                <div class="row-Value-width" style="text-align: left;"
                                    *ngIf="contactDetails.WorkNumber != ''">
                                    {{contactDetails.WorkNumber | phoneNumber}}</div>
                                <div style="text-align: left;" *ngIf="contactDetails.WorkNumber == ''"></div>
                            </div>

                            <div class="row-details" *ngIf = "contactDetails.HomeNumber2">
                                <div class="row-Label-width">Home Phone 2</div>
                                <div class="row-Value-width" style="text-align: left;">{{contactDetails.HomeNumber2 |
                                    phoneNumber}}</div>
                            </div>

                            <div class="row-details" style="margin-top: 10px"
                                *ngIf="contactDetails.ParentType != 'Emergency'">
                                <div class="row-Label-width">Portal Access</div>
                                <div class="row-Value-width" style="text-align: left;">
                                    {{contactDetails.ParentPortalAccess ? 'Y' : 'N'}}
                                </div>
                            </div>

                            <div class="row-details" *ngIf="contactDetails.ParentType != 'Emergency'">
                                <div class="row-Label-width">Last Login</div>
                                <div class="row-Value-width" style="text-align: left;">{{contactDetails.LastLogin | date:'MM/dd/yy hh:mm a'}}
                                </div>
                            </div>
                        </div>

                        <div style="display: flex; flex: 1; flex-direction: column; margin-left: 10%;max-width: 30%; ">
                            <div *ngIf="contactDetails.ParentType != 'Emergency'">
                                <div class="row-detail-label" style="padding: 0px;">Primary Address</div>
                                <div style="margin-left: 10px;padding: 0px;"
                                    [innerHtml]="contactDetails.PrimaryAddressLine1">
                                </div>
                            </div>
                            <div *ngIf="contactDetails.ParentType == 'Household'" style="margin-top: 10px">
                                <div class="row-detail-label" style="display: flex; flex: 1">Mailing Address</div>
                                <div *ngIf="contactDetails.PrimaryAddressLine1 != contactDetails.MailingAddressLine1"
                                    style="margin-left: 10px;" [innerHtml]="contactDetails.MailingAddressLine1">
                                </div>
                                <div *ngIf="contactDetails.PrimaryAddressLine1 == contactDetails.MailingAddressLine1"
                                    style="margin-left: 10px;"><i>Same as Primary Address</i>
                                </div>
                            </div>
                            <div *ngIf="contactDetails.ParentType == 'Emergency'" style="margin-top: 10px">
                                <div class="row-detail-label" style="display: flex; flex: 1">Comment</div>
                                <div style="margin-left: 10px;">{{contactDetails.Comment}}</div>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- WHEN PARENT TYPE IS EMERGENCY -->
                <div *ngIf="!contactDetails.IsHeader && contactDetails.ParentType == 'Emergency'"
                    style="flex: 1; display: flex; flex-direction: column">
                    <div style="display: flex; flex: 1; white-space: nowrap; margin-bottom: 10px;" *ngIf="!contactDetails.IsRestricted">Student may leave with
                        this person</div>

                    <div style="display: flex; flex: 1; white-space: nowrap; margin-bottom: 10px;" *ngIf="contactDetails.IsRestricted"
                    class="restricted-contact">Student may NOT leave
                        with this person</div>

                    <div style="display: flex; flex: 1">
                        <div style="display: flex; flex: 1; flex-direction: column;max-width: 60%;">
                            <div class="row-details">
                                <div class="row-Label-width">Work Phone</div>
                                <div class="row-Value-width" style="text-align: left;"
                                    *ngIf="contactDetails.WorkNumber != ''">
                                    {{contactDetails.WorkNumber | phoneNumber}}</div>
                                <div style="text-align: left;" *ngIf="contactDetails.WorkNumber == ''"></div>
                            </div>
                            <div *ngIf="contactDetails.ParentType == 'Emergency'" style="margin-top: 10px">
                                <div class="row-detail-label" style="display: flex; flex: 1">Comment</div>
                                <div>{{contactDetails.Comment}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-cell>
        </ng-container>


        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: false"></mat-header-row>
        <!-- Data rows -->
        <mat-row *matRowDef="let row; columns: displayedColumns; let i = index;" id="AHdataRow{{i}}" tabindex="0"
            (click)="toggleExpanded(row)" (keydown)="rowKeyPress($event, row)"
            [ngStyle]="{'border-bottom-width':checkExpanded(row) ? '0px' : '1px'}" style="padding:0;overflow: hidden;"
            matRipple>
        </mat-row>

        <!-- Detail row -->
        <!-- 'overflow: hidden' is required for animation to render properly -->
        <mat-row *matRowDef="let row; columns: ['expandedDetail']"
            [@detailExpand]="checkExpanded(row) ? 'expanded' : 'collapsed'" style="overflow: hidden;">
        </mat-row>
    </mat-table>
</div>
